// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3awq8","footer":"ModalInfo_footer__1Ktqx"};